<template>
    <div class="header-wrapper" 
         @mouseenter="showMegaMenu" 
         @mouseleave="hideMegaMenu">
        <div class="header">
            <div class="title">
                <div class="logo">
                    <a href="https://www.yells.com.cn/#/home" target="_blank">
                        <img src="../assets/publicImg/logo.svg" alt="">
                    </a>
                </div>
                <div class="content">
                                    <div class="btnParent">
                    <div class="nav-item" 
                         v-for="(item, index) in router" 
                         :key="index">
                        <div class="btn" @click="setUrlFn(item.link, index)">
                            <p :class="{ clickBtn: selectedIndex === index }">{{item.title}}</p>
                        </div>
                        <!-- 每个导航项对应的下拉菜单列 -->
                        <div class="dropdown-column" :class="{ show: showMegaMenuPanel }">
                            <div class="column-items">
                                <div class="menu-item"
                                     v-for="(child, childIndex) in item.children"
                                     :key="childIndex"
                                     @click="handleChildClick(child)">
                                    {{child.title}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                    <div class="contact-info">
                        <div class="contact-item">
                            <img src="../assets/publicImg/message.svg" alt="邮件" class="contact-icon">
                            <span>scb@yells.com.cn</span>
                        </div>
                        <div class="contact-item">
                            <img src="../assets/publicImg/phone.svg" alt="电话" class="contact-icon">
                            <span>021-36509952</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <!-- 统一的下拉菜单背景 -->
        <div class="mega-menu-backdrop" :class="{ show: showMegaMenuPanel }"></div>
    </div>
</template>
<script>
    export default {
        name: "titleCom",
        data() { //初始数据
            return {
                router: [
                    {
                        title: "首页",
                        link: '/home',
                        children: [
                            { title: "产品序列", action: () => this.scrollToSection('solutions') },
                            { title: "服务客户", action: () => this.scrollToSection('service-clients') },
                            { title: "最新资讯", action: () => this.scrollToSection('news') },
                            { title: "联系我们", action: () => this.scrollToSection('contact') }
                        ]
                    },
                    {
                        title: "关于研视",
                        link: '/aboutYells',
                        children: [
                            { title: "公司简介", action: () => this.scrollToAboutSection('company-intro') },
                            { title: "研视大事记", action: () => this.scrollToAboutSection('history') },
                            { title: "重要荣誉", action: () => this.scrollToAboutSection('honor') },
                            { title: "合作伙伴", action: () => this.scrollToAboutSection('partners') },
                            { title: "销售大区", action: () => this.scrollToAboutSection('sales-area') },
                            { title: "在线留言", action: () => this.scrollToAboutSection('online-message') },
                            { title: "合作承诺", action: () => this.scrollToAboutSection('cooperation') }
                        ]
                    },
                    {
                        title: "解决方案",
                        link: '/solution',
                        children: [
                            { title: "能力地图", action: () => this.toAtomMap() },
                            { title: "产品与服务", action: () => this.scrollToSolutionSection('products') }
                        ]
                    },
                    {
                        title: "资讯",
                        link: '/information',
                        children: [
                            { title: "研视动态", action: () => this.$router.push('/information/1') },
                            { title: "热点推荐", action: () => this.$router.push('/information/1') }
                        ]
                    },
                    {
                        title: "加入我们",
                        link: '/recruit',
                        children: [
                            { title: "招聘", action: () => this.$router.push('/recruit') },
                            { title: "工作在研视", action: () => this.scrollToRecruitSection('work-life') }
                        ]
                    }
                ],
                selectedIndex: null,
                showMegaMenuPanel: false
            }
        },
        computed: {
            METAVERSE_URL() {
                return this.$store.state.METAVERSE_URL;
            }
        },
        watch: { //监听
            '$route'(newRoute) {
                this.setRouter(this.getTrimmedPath(newRoute.path));
            },
        },
        methods: { //函数
            setUrlFn(url, index) {
                this.selectedIndex = index;
                this.$router.push(url)
            },
            setRouter(val) {
                this.router.forEach((item, index) => {
                    if (item.link === val) {
                        this.setUrlFn(val, index)
                    }
                });
            },
            getTrimmedPath(path) {
                const secondSlashIndex = path.indexOf('/', 1); // 查找第二个斜杠的位置（从索引为1开始）
                if (secondSlashIndex !== -1) {
                    return path.substring(0, secondSlashIndex); // 截取需要的部分
                }
                return path;
            },
            // 整体菜单面板控制
            showMegaMenu() {
                this.showMegaMenuPanel = true;
            },
            hideMegaMenu() {
                this.showMegaMenuPanel = false;
            },
            handleChildClick(child) {
                this.hideMegaMenu();
                child.action();
            },
            // 以下方法复制自 bottomCom.vue
            toAtomMap() {
                window.open(this.METAVERSE_URL, "_blank");
            },
            // 滚动到首页对应位置
            scrollToSection(section) {
                // 如果不在首页，先跳转到首页
                if (this.$route.path !== '/home') {
                    this.$router.push('/home').then(() => {
                        this.$nextTick(() => {
                            this.scrollToElement(section);
                        });
                    });
                } else {
                    this.scrollToElement(section);
                }
            },
            // 滚动到关于研视页面对应位置
            scrollToAboutSection(section) {
                // 跳转到关于研视页面并滚动到对应位置
                this.$router.push('/aboutYells').then(() => {
                    this.$nextTick(() => {
                        this.scrollToAboutElement(section);
                    });
                });
            },
            // 滚动到解决方案页面对应位置
            scrollToSolutionSection(section) {
                // 跳转到解决方案页面并滚动到对应位置
                this.$router.push('/solution').then(() => {
                    this.$nextTick(() => {
                        this.scrollToSolutionElement(section);
                    });
                });
            },
            // 滚动到招聘页面对应位置
            scrollToRecruitSection(section) {
                // 跳转到招聘页面并滚动到对应位置
                this.$router.push('/recruit').then(() => {
                    this.$nextTick(() => {
                        this.scrollToRecruitElement(section);
                    });
                });
            },
            // 滚动到指定元素
            scrollToElement(section) {
                setTimeout(() => {
                    let scrollTop = 0;
                    switch(section) {
                        case 'company-intro':
                            scrollTop = 506; // 我们是谁部分
                            break;
                        case 'solutions':
                            scrollTop = 950; // 解决方案部分
                            break;
                        case 'service-clients':
                            scrollTop = 1450; // 服务客户部分（轮播）
                            break;
                        case 'news':
                            scrollTop = 2000; // 新闻资讯部分
                            break;
                        case 'contact':
                            scrollTop = 2500; // 联系我们部分
                            break;
                        default:
                            scrollTop = 0;
                    }
                    window.scrollTo({
                        top: scrollTop,
                        behavior: "smooth",
                    });
                }, 100);
            },
            // 滚动到关于研视页面指定位置
            scrollToAboutElement(section) {
                setTimeout(() => {
                    let targetElement = null;
                    let elementId = '';
                    
                    // 根据section映射到对应的元素ID
                    switch(section) {
                        case 'company-intro':
                            elementId = 'company-intro-section';
                            break;
                        case 'history':
                            elementId = 'history-section';
                            break;
                        case 'honor':
                            elementId = 'honor-section';
                            break;
                        case 'partners':
                            elementId = 'partners-section';
                            break;
                        case 'online-message':
                            elementId = 'online-message-section';
                            break;
                        case 'cooperation':
                            elementId = 'cooperation-section';
                            break;
                        case 'sales-area':
                            elementId = 'online-message-section';
                            break;
                        default:
                            // 默认滚动到页面顶部
                            window.scrollTo({
                                top: 0,
                                behavior: "smooth",
                            });
                            return;
                    }
                    
                    // 查找目标元素
                    targetElement = document.getElementById(elementId);
                    
                    if (targetElement) {
                        // 计算目标位置，减去50px偏移量以获得更好的视觉效果
                        const offsetTop = targetElement.offsetTop - 50;
                        window.scrollTo({
                            top: offsetTop,
                            behavior: "smooth",
                        });
                        console.log(`跳转到${section}区域，元素ID: ${elementId}`);
                    } else {
                        console.warn(`未找到元素ID: ${elementId}，使用备用滚动方案`);
                        // 备用方案：滚动到页面顶部
                        window.scrollTo({
                            top: 0,
                            behavior: "smooth",
                        });
                    }
                }, 100);
            },
            // 滚动到解决方案页面指定位置
            scrollToSolutionElement(section) {
                setTimeout(() => {
                    let scrollTop = 0;
                    switch(section) {
                        case 'products':
                            scrollTop = 666; // 慧眼系列部分
                            break;
                        default:
                            scrollTop = 0;
                    }
                    window.scrollTo({
                        top: scrollTop,
                        behavior: "smooth",
                    });
                }, 100);
            },
            // 滚动到招聘页面指定位置
            scrollToRecruitElement(section) {
                setTimeout(() => {
                    let scrollTop = 0;
                    switch(section) {
                        case 'work-life':
                            scrollTop = 800; // 工作在研视部分
                            break;
                        default:
                            scrollTop = 0;
                    }
                    window.scrollTo({
                        top: scrollTop,
                        behavior: "smooth",
                    });
                }, 100);
            },
        },
        mounted() {
            this.setRouter(this.$route.path)
        }
    }
</script>

<style scoped lang="scss">
    .header-wrapper {
        width: 100vw;
        position: relative;
        z-index: 100;
    }
    
    .header{
        width: 100vw;
        background: rgba(255, 255, 255, 0.6);
        backdrop-filter: blur(10px);
        -webkit-backdrop-filter: blur(10px);
        position: relative;
        z-index: 101;
    }
    .title{
        width: 90%;
        max-width: 1400px;
        min-width: 800px;
        height: 60px;
        margin: auto;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
        
        // 响应式设计
        @media (max-width: 768px) {
            width: 95%;
            min-width: 320px;
        }
    }
    .logo{
        width: 200px;
        display: flex;
        align-items: center;
        flex-shrink: 0;
        
        // 响应式设计
        @media (max-width: 768px) {
            width: 150px;
        }
        
        img{
            margin: auto;
            height: 18px;
            cursor: pointer;
        }
    }
    .content{
        display: flex;
        align-items: center;
        height: 60px;
        justify-content: space-between;
        gap: 70px;
        
        .btnParent{
            display: flex;
            justify-content: center;
            gap: 70px;
            height: 60px;
            
            // 响应式设计
            @media (max-width: 1200px) {
                gap: 50px;
            }
            
            @media (max-width: 768px) {
                gap: 20px;
            }
        }
        
        .nav-item{
            position: relative;
            display: flex;
            flex-direction: column;
            align-items: center;
        }
        
        .btn{
            display: flex;
            
            p{
                cursor: pointer;
                height: 41px;
                padding: 0 15px;
                line-height: 62px;
                color: #2C333A;
                text-align: center;
                font-family: "Noto Sans SC Variables", sans-serif;
                font-size: 12px;
                font-style: normal;
                font-weight: 400;
                border-bottom: 2px solid transparent;
                white-space: nowrap;
                &:hover{
                    color: #388BFF;
                }
            }
            .clickBtn{
                color: #161A1D;
                height: 58px;
                line-height: 62px;
                border-bottom: 2px solid #161A1D;
                &:hover{
                    color: #2C333A;
                }
            }
        }
        
        .dropdown-column{
            position: absolute;
            top: 38px;
            left: 50%;
            transform: translateX(-50%);
            min-width: 120px;
            padding: 20px 0;
            z-index: 102;
            
            // 下拉动画
            max-height: 0;
            overflow: hidden;
            opacity: 0;
            transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
            
            &.show {
                max-height: 350px;
                opacity: 1;
            }
            
            .column-items {
                display: flex;
                flex-direction: column;
                gap: 10px;
                
                .menu-item {
                    padding: 6px 15px;
                    color: #596773;
                    font-family: "Noto Sans SC Variables", sans-serif;
                    font-size: 12px;
                    font-weight: 400;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    white-space: nowrap;
                    text-align: center;
                    
                    &:hover {
                        color: #388BFF;
                        transform: translateX(4px);
                    }
                }
            }
        }
        
        .contact-info{
            display: flex;
            align-items: center;
            gap: 20px;
            
            // 响应式设计
            @media (max-width: 768px) {
                display: none;
            }
            
            .contact-item{
                display: flex;
                align-items: center;
                gap: 6px;
                
                span{
                    font-family: "Alibaba PuHuiTi 2.0", sans-serif;
                    font-size: 12px;
                    font-weight: 250;
                    color: #596773;
                    white-space: nowrap;
                }
                
                .contact-icon{
                    width: 14px;
                    height: 14px;
                }
            }
        }
    }
    
    // 统一的下拉菜单背景
    .mega-menu-backdrop {
        position: absolute;
        top: 60px;
        left: 0;
        width: 100%;
        height: 0;
        background: rgba(255, 255, 255, 0.6);
        backdrop-filter: blur(10px);
        -webkit-backdrop-filter: blur(10px);
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
        z-index: 100;
        
        // 下拉动画
        transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
        opacity: 0;
        
        &.show {
            height: 300px;
            opacity: 1;
        }
    }
</style>